import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { selectGeolocationPosition, selectIsGeoLocationOn } from '../../store/geolocation/geolocation.selectors'
import { computeETAFromGeoloc } from '../../store/itinerary/itinerary.actions'
import { getRouteLengthLabel, getRouteTimeLabel } from '../../store/itinerary/routes.selectors'
import { withOnlyPE } from '../Device'
import { withEmptyFallbackErrorBoundary } from '../error/EmptyFallbackErrorBoundary'
import StepUpNumber from '../genericComponents/StepUpNumber'
import SVGIcon from '../svg/SVGIcon'
import { locationHasCoords } from '../utils/location'
import { useAction } from '../utils/react-redux'
import s from './ETA.less'
import waves from './assets/waves.svg'

const useResetRouteOnCoordinatesChanged = (setRoute, locationCoords) => {
  useEffect(() => {
    setRoute(undefined)
  }, [locationCoords])
}

const useETARoute = coordinates => {
  const [route, setRoute] = useState(null)

  const execComputeETAFromGeoloc = useAction(computeETAFromGeoloc)

  const isGeoLocationEnabled = useSelector(selectIsGeoLocationOn)
  const geolocationPosition = useSelector(selectGeolocationPosition)

  useResetRouteOnCoordinatesChanged(setRoute, locationHasCoords)

  useEffect(() => {
    if (coordinates && isGeoLocationEnabled && geolocationPosition) {
      execComputeETAFromGeoloc(coordinates).then(route => setRoute(route))
    }
  }, [isGeoLocationEnabled, geolocationPosition, coordinates])

  return route
}

export const ETA = ({ coordinates }) => {
  const route = useETARoute(coordinates)

  if (!route) return <></>

  return (
    <div className={s.ETA}>
      {route && (
        <span className={s.icon}>
          <SVGIcon icon={route?.icon} />
        </span>
      )}
      <span className={s.length}>
        <StepUpNumber label={getRouteLengthLabel(route)} mainClassName={s.bigNumber} restClassName={s.rest} />
      </span>
      <span className={s.time}>
        <StepUpNumber label={getRouteTimeLabel(route)} mainClassName={s.bigNumber} restClassName={s.rest} />
        <span className={s.waves}>
          <SVGIcon url={waves} />
        </span>
      </span>
    </div>
  )
}

export default withOnlyPE(withEmptyFallbackErrorBoundary(ETA))
